import { pickDefaultModelResult } from '@upright/common/model/data-point-pickers';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useWeightSetItemResults } from '../../../../api/model/output/scores/weight-sets';
import { HoldingsHistogram } from '../../../../common/upright/model/output/scores/holdings-histogram';
import { getDefaultRelease } from '../../../../untidy/redux/selectors';
import { useRenderViewContext } from '../../context';

export const RenderViewHoldingsHistogram = () => {
  const context = useRenderViewContext();

  // TODO OA: Change to fetch own data with ReactQuery instead of getting it from RenderViewContext
  const scoreData = context.data?.[0];
  const modelResults = scoreData?.modelResults;
  const modelResult = modelResults && pickDefaultModelResult(modelResults);
  const weightSetId = modelResult?.weightSetId;

  const options = context.options;
  const selectedRelease = useSelector(getDefaultRelease);
  const release = options.release ?? selectedRelease;

  const itemsQuery = useWeightSetItemResults(weightSetId, release, {
    includeEuTaxonomyMetrics: false,
    includePaiMetrics: false,
  });
  const itemData = itemsQuery.data;

  if (!release || !scoreData || !itemData) {
    return <>Loading items...</>;
  }

  return (
    <Root>
      <HoldingsHistogram itemData={itemData} scoreData={scoreData} loadingFinished={true} />
    </Root>
  );
};

const Root = styled.div``;
